const ADD_BANK_ACCOUNT_GUIDE_URL =
    "https://help.navigatortruckinsurance.com/hc/en-us/articles/29734351716379-How-do-I-add-a-bank-account-ACH-in-Waypoint";

/** Chase bank connections made through instant verification expire, manually verified accounts don't */
export function ChaseManualVerificationTip({ className }: { className?: string }) {
    return (
        <p className={className}>
            Using Chase? Add your bank with manual verification to stop needing to reconnect.{" "}
            <a href={ADD_BANK_ACCOUNT_GUIDE_URL} target="_blank" rel="noreferrer" className="font-medium underline">
                See how
            </a>
        </p>
    );
}
